import { CheckSmall, ErrorSmall } from "@components/Icons"
import { breakpoints } from "@config/theme"
import styled, { css } from "styled-components"
import { BasicInput } from "../elements"

export const CheckMark = styled(CheckSmall)`
  width: 0.75rem;
  height: 0.75rem;
  background: white;

  fill: ${(p) => p.theme.colors.green.icon};
`

export const StyledInput = styled.input<{ hasError?: boolean }>`
  ${BasicInput};
  width: 100%;

  tr &:not([type="checkbox"]):not([type="radio"]) {
    -webkit-appearance: none;
  }

  &:disabled {
    background: ${(p) => p.theme.colors.card.default};
  }
  &:focus {
    outline: none;
    & + ${CheckMark} {
      display: none;
    }
  }
  ${(p) =>
    p.hasError &&
    css`
      border-color: ${p.theme.colors.red.border};
    `};
  &::-ms-clear {
    display: none;
  }
`

export const StyledTextarea = styled.textarea<{ hasError?: boolean }>`
  ${BasicInput};
  width: 100%;
  height: 5rem;
  padding: 0.5rem 1rem;
  line-height: 1.5rem;
  tr &:not([type="checkbox"]):not([type="radio"]) {
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
    & + ${CheckMark} {
      display: none;
    }
  }
  ${(p) =>
    p.hasError &&
    css`
      border-color: ${p.theme.colors.red.border};
    `};

  &::-ms-clear {
    display: none;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  svg {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }

  span {
    position: absolute;
    font-size: 0.75rem;
    left: 10px;
    margin: 0;
    color: ${(p) => p.theme.colors.red.text};
  }

  @media (max-width: ${breakpoints.medium}) {
    margin-left: 0;
  }
`

export const Error = styled(ErrorSmall)`
  width: 0.75rem;
  height: 0.75rem;
  background: white;

  fill: ${(p) => p.theme.colors.red.icon};
`
